import { Currencies, Currency } from '@column/column-ui-kit';

import countryCodeJSON from '~/data/wires/country-codes.json';
import { CreateCounterparty, FinancialInstitution, ValidateIBANObject } from '~/repositories';

type TemporaryData = {
  institution: FinancialInstitution | null;
  iban: ValidateIBANObject | null;
  currency: Currency | null;
  oldCounterpartyId: string | null;
};

export type FormData = CreateCounterparty & { temporaryData: TemporaryData };

export const countryName = (countryCode?: string) =>
  countryCodeJSON.find((entry) => entry.countryCode === countryCode)?.countryName;

export const currencyForCountry = (countryCode?: string) => {
  const currencyCode = countryCodeJSON.find((entry) => entry.countryCode === countryCode)?.currencyCode;
  return Currencies.find(({ code }) => code === currencyCode) ?? null;
};
